export const STATE = {
    PAID: 1,
    CANCEL: 2,
    DRAFT: 3,
    WAIT: 4,
    DONE: 5,
    UNKNOWN: 6
}